// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wdSs","col":"styles_col__1W7jY","actions":"styles_actions__2PqfU","conflict":"styles_conflict__2abPF"};